<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="enterpriseSectorExecutorId" :primary-key="form.enterpriseSectorExecutorId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Categorias e Responsáveis"
                 @onSubmit="onSubmit" @onItemRead="onItemRead" @onItemDelete="onItemDeleteDefault">


      <template #default>

        <t-input v-model="form.enterpriseSectorExecutorId" hidden/>

        <b-col cols="12" class="mb-2">

          <b-row>

            <b-col xl="9">

              <b-row>


                <t-input cols="4" v-model="form.executorId"
                         label="Responsável"
                         :options="executorOptions" required select/>


<!--                <t-input cols="4"
                         v-model="form.sectorId"
                         label="Categoria"
                         placeholder="Todos os setores"
                         :add-error="error.sectorId"
                         help="Caso desejar poderá especificar somente um setor responsável"
                         :options="sectorOptions" select/>-->

                <t-input cols="4" v-model="form.note" label="Obs."/>


              </b-row>

            </b-col>

            <b-col xl="3" class="button-form-inline">

              <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

              <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                {{ t('go-back') }}
              </b-link>

            </b-col>


          </b-row>


        </b-col>


      </template>

      <template #item(sector)="{item}">

        <span v-if="objValid(item.sector)">{{item.sector}}</span>
        <span v-else><b>Todos</b></span>

      </template>



    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import SectorService from "@/services/modules/agent/Sector.service";
import ExecutorService from "@/services/modules/agent/Executor.service";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'EnterpriseSectorExecutor',
  data() {
    return {
      path: "place/enterprise-sector-executor", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "enterpriseId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "enterpriseSectorExecutorId", keyDelete: "enterpriseSectorExecutorId"},
        {key: "executor", label: "Executor", cols: "5"},
        {key: "note", label: "Obs.", cols: "2"},
      ],
      form: {
        enterpriseId: this.foreignKey,
        enterpriseSectorExecutorId: 0,
        sectorId: 0,
        executorId: 0,
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        sectorId: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      sectorOptions: [],
      executorOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await ExecutorService.selectList().then((list) => {
        this.executorOptions = list
      }).catch(error => this.responseError(error))

      await SectorService.selectList().then((list) => {
        this.sectorOptions = list
      }).catch(error => this.responseError(error))

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.enterpriseSectorExecutorId)

    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    async onItemRead(id) {

      await this.onItemReadDefault(id, () => {

      })

    },

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
